/**
 * @module signUp
 */

/**
 * Sign up form
*/

module.exports = function() {
    document.querySelector( '#sign-up-form' ).addEventListener( 'submit', function( e ) {
        e.preventDefault();
        const emailInput = this.querySelector( '#sign-up-email' );
        const emailInputValue = emailInput.value.trim();

        let redirectUrl = this.dataset.action;

        if ( emailInput && emailInputValue !== '' ) {
            redirectUrl += '?email=' + encodeURIComponent( emailInputValue );
        }

        window.location.href = redirectUrl;
        return false;
    } );
};
